// extracted by mini-css-extract-plugin
module.exports = {"loginBoxContainer":"EULogin_loginBoxContainer__mfGjw","loginBox":"EULogin_loginBox__32TaJ","logo":"EULogin_logo__7UnES","error":"EULogin_error__mJKeC"};